import apiConfig from "./APIConfig";

const baseURL = apiConfig.appConfig.apiisf

export default baseURL;